import { canViewPurchasePrice } from '@/utils/permission'

const STORAGE_KEY = 'purchase_price_visible'

export function readPurchasePriceVisible() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw === null || raw === '') return true
    return raw === '1' || raw === 'true'
  } catch (e) {
    return true
  }
}

export function writePurchasePriceVisible(visible) {
  try {
    localStorage.setItem(STORAGE_KEY, visible ? '1' : '0')
  } catch (e) {
    /* ignore */
  }
}

/** 有权限且未手动隐藏 */
export function showPurchasePrice(auth, visible) {
  return canViewPurchasePrice(auth) && visible !== false
}
